import React from "react";
export const SuitCaseIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="2.5"
      y="6.22949"
      width="15"
      height="10.4374"
      rx="1"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M7.20673 6.25858V4.3335C7.20673 3.78121 7.65444 3.3335 8.20673 3.3335H11.7933C12.3456 3.3335 12.7933 3.78121 12.7933 4.3335V6.25858"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);
